import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import { store } from "../../store";
import { resetStore } from "../../actions";
import { middlewareService } from "../../shared/service";
import { utils } from "../../core/helpers/utils";

export const authHelpers = {
  setAuthCookie,
  getAuthCookie,
  logout,
  isUserAuthenticated,
  getSignupError,
  getLoginError,
  setAuthCookie,
  isUserAuthenticatedNew,
};

function setAuthCookie(value, numberOfDays) {
  const cookies = new Cookies();
  let date = new Date();
  date.setTime(date.getTime() + numberOfDays * 24 * 60 * 60 * 1000);
  cookies.set("oroAUTH", value, { expires: date, path: "/", secure: true, samesite: "SAMESITE", httponly: "HttpOnly" });
}

function getAuthCookie() {
  const cookies = new Cookies();
  return cookies.get("oroAUTH");
}

function logoutNew(isFromMf) {
  const options = {
    path: "/",
  };
  const cookies = new Cookies();
  cookies.remove("oroAUTH", options);
  cookies.remove("connect.sid", options);
  localStorage.removeItem('showBanner');
  setTimeout(() => {
    let prodLoginPath = isFromMf
      ? process.env.REACT_APP_AMAZON_DASHBOARD === "true"
        ? "/amazon/login/?view=main"
        : "/loginmf"
      : process.env.REACT_APP_AMAZON_DASHBOARD === "true"
      ? "/amazon/login/?view=main"
      : "/login";

    let url = process.env.REACT_APP_DASHBOARD_PREFIX
      ? prodLoginPath
      : "/#/login";
    store.dispatch(resetStore());
    window.location.href = url;
  }, 150);
}

function logout(showDialog, isFromMf) {
  if (showDialog) {
    setTimeout(logoutNew, 2000);
    let msg = "Your session is expired, please login again";
    return toast.error(msg, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: false,
    });
  } else {
    logoutNew(isFromMf);
  }
}

function isUserAuthenticated() {
  return getAuthCookie();
}

async function isUserAuthenticatedNew() {
  return await middlewareService.getApiData("/authStatus").then((result) => {
    const response = utils.parsePayload(result);
    if (!response.email || !response.state) return false;
    return true;
  });
}

function getSignupError(errorCode) {
  var error = {};
  switch (errorCode) {
    case 2:
      error["message"] = "This email is already registered.";
      error["field"] = "email";
      break;
    case 4:
      error["message"] = "Passwords dont match.";
      error["field"] = "password";
      break;
    case 5:
    case 7:
      error["message"] = "The email you have entered is not valid.";
      error["field"] = "email";
      break;
    case 6:
      error["message"] = "Not a valid Phone number.";
      error["field"] = "phone";
      break;
    default:
      error["message"] = "Error encounterd. Please try again.";
      break;
  }

  return error;
}

function getLoginError(errorCode) {
  var error = {};
  switch (errorCode) {
    case 2:
      error["message"] = "No such email. Authentication Failed";
      break;
    case 3:
      error["message"] = "Authentication Failed";
      break;
    case 5:
      error["message"] = "Email not verified. Check your email";
      break;
    default:
      error["message"] = "Some unknown error encounterd";
  }

  return error;
}
